// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"4c2d8b9f","726":"458b3ded","813":"c72ef672"}[chunkId] + ".chunk.js";
};